// extracted by mini-css-extract-plugin
export var statItem = "_bx-1";
export var statsRow = "_bx-0";